/** 导出类型枚举 */
export enum ExportType {
  csv = 0,
  excel = 1
}
